import usePersistFn from '@/hooks/usePersistFn';
import { useOperationConfigModelStore } from '@/models/operation-config/operationConfig';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import { InternalClassName } from '@/shared/constant/InternalClassName';
import { HttpApiRequestBodyType } from '@tarslib/types/lib/httpApi';
import React from 'react';

export function useResponseParameterValue(value: HttpApiServerType) {
  const responses = React.useMemo(() => {
    if (value.requestBody.type === HttpApiRequestBodyType.GraphQL) {
      return undefined;
    }

    return value.responses;
  }, [value]);

  const responseKeys = React.useMemo(() => {
    return responses?.map((x, i) => String(x.id ?? i));
  }, [responses]);

  const selectedResponseKey = useOperationConfigModelStore((x) => x.selectedResponseKey);
  const setSelectedResponseKey = useOperationConfigModelStore((x) => x.setSelectedResponseKey);

  React.useEffect(() => {
    setSelectedResponseKey(responseKeys?.[0]);
  }, [responseKeys, setSelectedResponseKey]);

  const activeKey = React.useMemo(() => {
    return selectedResponseKey ?? responseKeys?.[0];
  }, [responseKeys, selectedResponseKey]);

  const timerRef = React.useRef(-1);
  const scrollToResponseTitle = usePersistFn(() => {
    const responseTitle = document.querySelector(
      `.${InternalClassName.ResponseTitle}`,
    ) as HTMLDivElement | null;
    if (!responseTitle) {
      return;
    }
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      if (!responseTitle) {
        return;
      }

      document.getElementById(InternalClassName.MainScrollContainer)?.scrollTo({
        top: responseTitle.offsetTop,
      });
    }, 0);
  });

  const onChange = usePersistFn((v) => {
    setSelectedResponseKey(v ?? '');
    scrollToResponseTitle();
  });

  return {
    activeKey,
    onChange,
    responses,
  };
}
